import JsonFormsWrapper from '@/components/common/jsonForms/jsonFormsWrapper/JsonFormsWrapper'
import {dateJsonSchema, dateUiSchema} from '@/services/schema/DateJSON'
import {IdentificationJsonSchema, IdentificationUiSchema} from '@/services/schema/IdentificationJSON'
import {OSDJsonSchema, OSDUiSchema} from '@/services/schema/OrderStatusDetailJSON'

import {PageContainer} from '@/components/organisms'
import {SectionTitle} from '@/components/molecules'

const OrderInfo = ({OrderDetails}) => {
  // Destructure OrderDetails for easy access
  const {
    createdDateTime,
    requestedDeliveryDateTime,
    invoiceDateTime,
    orderType,
    orderLocationId,
    sourceOrderId,
    customerPold,
    referenceInvoiceId,
    customerRemarksText,
    routeId,
    routeTypeId,
    routeSalesRepWorkForceId,
    rejectionReasonDescription,
  } = OrderDetails

  // Helper component to render each section
  const RenderSection = ({id, label, jsonSchema, uiSchema, data}) => (
    <div>
      <SectionTitle isBorderVisible={true} id={id} label={label} />
      <div className="pt-5">
        <JsonFormsWrapper jsonschema={jsonSchema} uischema={uiSchema} data={data} />
      </div>
    </div>
  )

  return (
    <PageContainer>
      {/* Date Section */}
      <RenderSection
        id="dates"
        label="Dates"
        jsonSchema={dateJsonSchema}
        uiSchema={dateUiSchema}
        data={{
          orderDate: createdDateTime,
          expectedDeliveryDate: requestedDeliveryDateTime,
          invoiceDate: invoiceDateTime,
        }}
      />

      {/* Identification Details Section */}
      <RenderSection
        id="identification_details"
        label="Identification Details"
        jsonSchema={IdentificationJsonSchema}
        uiSchema={IdentificationUiSchema}
        data={{
          orderType,
          category: 'should be derived from product API',
          warehouseID: orderLocationId,
          localOrderID: orderLocationId,
          cartID: sourceOrderId,
          customerPONumber: customerPold,
          referenceInvoiceID: referenceInvoiceId,
          customerRemarkNote: customerRemarksText,
        }}
      />

      {/* Order Status and Details Section */}
      <RenderSection
        id="order_status_and_details"
        label="Order Status and Details"
        jsonSchema={OSDJsonSchema}
        uiSchema={OSDUiSchema}
        data={{
          routeID: routeId,
          routeTypeID: routeTypeId,
          routeSalesRepWorkForceID: routeSalesRepWorkForceId,
          pointsReturned: 'Not Required',
          rejectReason: rejectionReasonDescription,
          templateCancellationReason: 'Not Required',
        }}
      />
    </PageContainer>
  )
}

export default OrderInfo
